import { createApp } from 'vue'
import App from './App.vue'
import VueGtm from 'vue-gtm';

createApp(App).use(VueGtm, { id: 'GTM-5L2JZHRK' }).mount('#app')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .catch(error => {
        console.error('Erro ao registrar service worker:', error);
      });
  });
}
